import {all, call, fork, put, takeEvery} from 'redux-saga/effects';
import {ActionType} from 'typesafe-actions';
import {ApiResult} from '../../types/api-result';
import {VehiclesActionTypes, VehicleWithFitmentsAndJobs} from './types';
import {handleUnexpectedErrorWithToast} from '../http-error-handler';
import {fetchVehicleFailure, fetchVehicleRequest, fetchVehicleSuccess} from './actions';
import VehiclesApi from '../../api/vehicles-api';

function *handleFailure(err: any) {
    yield call(handleUnexpectedErrorWithToast, err);
}

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export function* handleGet(action: ActionType<typeof fetchVehicleRequest>) {
    try {
        const request = action.payload;
        const result: ApiResult<VehicleWithFitmentsAndJobs> = yield call(VehiclesApi.getVehicle, request);

        if (result.error) {
            yield call(fetchVehicleFailure, result.error);
        } else {
            yield put(fetchVehicleSuccess(result.data!));
        }
    } catch (err) {
        yield call(handleFailure, err);
    }
}

function* watchRequests() {
    yield takeEvery(VehiclesActionTypes.FETCH_VEHICLE_REQUEST, handleGet);
}

function* vehiclesSaga() {
    yield all([fork(watchRequests)]);
}

export default vehiclesSaga;
